/** Origen canónico del sitio público — OAuth Twitch/Discord debe usar SIEMPRE este host. */
export const PUBLIC_SITE_ORIGIN = 'https://eugenial.com.ar';

export function getPublicSiteOrigin(): string {
  if (typeof window === 'undefined') {
    return PUBLIC_SITE_ORIGIN;
  }
  const { hostname, origin } = window.location;
  if (hostname === 'eugenial.com.ar' || hostname === 'www.eugenial.com.ar') {
    return PUBLIC_SITE_ORIGIN;
  }
  return origin;
}

/** www.eugenial.com.ar rompe OAuth (redirect_mismatch en Twitch). */
export function redirectToCanonicalSite(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.location.hostname !== 'www.eugenial.com.ar') return false;
  const { pathname, search, hash } = window.location;
  window.location.replace(`${PUBLIC_SITE_ORIGIN}${pathname}${search}${hash}`);
  return true;
}
